import React, { FunctionComponent } from "react";
import styles from "./ErrorPage.module.scss";

const ErrorPage: FunctionComponent = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                <span className={styles.tagline}>500</span>
                <h1 className={styles.headline}>An error occured</h1>
            </div>
        </div>
    );
};

export default ErrorPage;